import {
  Paper,
  Table,
  TableBody,
  TableFooter,
  TableCell,
  TableContainer,
  TablePagination,
  TableHead,
  TableRow,
  Typography,
  Skeleton,
  Button,
} from '@mui/material';
import React from 'react';
import {useGetOrganizationsQuery} from 'api';
import AddIcon from '@mui/icons-material/Add';
import OrganizationDeleteIconButton from './OrganizationDeleteIconButton';
import CreateOrganizationModal from './OrganizationModal';
import OrganizationEditIconButton from './OrganizationEditIconButton';

const totalColumns = 3;

function OrganizationsTable() {
  const {data, isLoading, isError, isSuccess} = useGetOrganizationsQuery();
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      <CreateOrganizationModal
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      />
      <TableContainer component={Paper}>
        <Table sx={{minWidth: 650}} aria-label="Organizations Table">
          <TableHead>
            <TableRow>
              <TableCell colSpan={totalColumns - 1}>Organizations</TableCell>
              <TableCell align="right">
                <Button
                  onClick={() => {
                    setIsOpen(true);
                  }}
                  disableElevation
                  variant="contained"
                  endIcon={<AddIcon />}
                >
                  Add
                </Button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell align="center">Name</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isSuccess &&
              Boolean(data.data?.length) &&
              data.data.map(row => (
                <TableRow key={row._id} sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                  <TableCell component="th" scope="row">
                    {row._id}
                  </TableCell>
                  <TableCell align="center">{row.name}</TableCell>
                  <TableCell align="right">
                    <OrganizationEditIconButton organization={row} />
                    <OrganizationDeleteIconButton organizationId={row._id} />
                  </TableCell>
                </TableRow>
              ))}
            {Boolean(isSuccess && !data.data?.length) && (
              <TableRow>
                <TableCell colSpan={totalColumns}>No Organization found</TableCell>
              </TableRow>
            )}
            {isError && (
              <TableRow>
                <TableCell colSpan={totalColumns}>
                  <Typography color="error">Failed to fetch Organizations.</Typography>
                </TableCell>
              </TableRow>
            )}
            {isLoading && (
              <TableRow>
                {Array.from(Array(totalColumns).keys()).map(key => (
                  <TableCell key={key}>
                    <Skeleton variant="text" />
                  </TableCell>
                ))}
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                count={100}
                page={0}
                onPageChange={() => {
                  // console.log('onPageChange', rest);
                }}
                rowsPerPage={10}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </>
  );
}

export default OrganizationsTable;
